import React from "react";
import { Input } from "../Input/Input";

const WeddingStyle = ({ handleChange, sectionStyles, formData, errors }) => {
  // Define options for each section
  const visionOptions = [
    { label: "Romantic & dreamy", value: "romantic" },
    { label: "Bohemian and free-spirited", value: "bohemian" },
    { label: "Chic & modern", value: "chic" },
    { label: "Rustic & natural", value: "rustic" },
    { label: "Classic and timeless", value: "classic" },
    { label: "Unique and creative", value: "unique" },
  ];

  const colorPaletteOptions = [
    { label: "Blush, cream, and gold", value: "blush" },
    { label: "Soft neutrals (ivory, beige, taupe)", value: "neutrals" },
    { label: "Navy, burgundy, and green", value: "navy" },
    { label: "Rustic & natural", value: "rustic" },
    { label: "Bright and bold (fuchsia, orange, teal)", value: "bright" },
    { label: "Earth tones (olive, terracotta, sienna)", value: "earth" },
  ];

  const floralOptions = [
    { label: "Classic & elegant", value: "Classic & elegant" },
    { label: "Rustic & natural", value: "Rustic & natural" },
    { label: "Romantic & whimsical seasonal", value: "Romantic & whimsical seasonalc" },
    { label: "Bold & vibrant", value: "Bold & vibrant" },
    { label: "Modern & minimalist", value: "Modern & minimalist" },
    { label: "Favorites", value: "Favorites" },
  ];

  return (
    <section className={`p-3 mb-6 lg:p-5 mt-6 ${sectionStyles.alignSection}`}>
      <h3 className="mb-4 text-left text-2xl font-semibold">
        Wedding <span className="uppercase">Style</span> & Aesthetic
      </h3>

      {/* Vision Section */}
      <div className="mb-6">
        <h4 className="mb-2 text-xl font-semibold">What's your vision for the wedding?</h4>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {visionOptions.map((option) => (
            <Input
              key={option.value}
              title={option.label}
              type="checkbox"
              name="vision"
              value={option.value}
                 checked={
                  formData.vision &&
                  formData.vision.split(", ").includes(option.value)
                 }
              handleChange={handleChange}
              sectionStyles={`${sectionStyles.label} flex items-center`}
              // error={errors.vision}
              className={`mr-2 ${sectionStyles.checkbox}`}
            />
          ))}
        </div>
        <div className="flex items-center mt-4">
          <Input
            title="Other:"
            type="text"
            name="visionOtherDetails"
            value={formData.visionOtherDetails || ""}
            handleChange={handleChange}
            sectionStyles={`${sectionStyles.label}`}
            // error={errors.visionOtherDetails}
            className="flex-1 border-b-2 border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            divClassName="w-full"
            disabled={!formData.visionOtherChecked}
          />
        </div>

        {/* {(errors.vision || errors.visionOtherDetails) && (
          <p className="text-red-500 text-sm">
            {errors.vision || errors.visionOtherDetails}
          </p>
        )} */}
      </div>

      {/* Color Palette Section */}
      <div className="mb-6">
        <h4 className="mb-2 text-xl font-semibold">Do you have a color palette in mind?</h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {colorPaletteOptions.map((option) => (
            <Input
              key={option.value}
              title={option.label}
              type="checkbox"
              name="colorPalette"
              value={option.value}
              checked={formData.colorPalette && formData.colorPalette.split(", ").includes(option.value)}
              handleChange={handleChange}
              sectionStyles={`${sectionStyles.label} flex items-center`}
              // error={errors.colorPalette}
              className={`mr-2 ${sectionStyles.checkbox}`}
            />
          ))}
        </div>
        <div className="flex flex-col md:w-full w-full">
          <Input
            title="Other:"
            type="text"
            name="colorPaletteOtherDetails"
            value={formData.colorPaletteOtherDetails || ""}
            handleChange={handleChange}
            sectionStyles={`${sectionStyles.label}`}
            // error={errors.colorPaletteOtherDetails}
            className="flex-1 border-b-2 border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            disabled={!formData.colorPaletteOtherChecked}
          />
        </div>

        {/* {(errors.colorPalette || errors.colorPaletteOtherDetails) && (
          <p className="text-red-500 text-sm">
            {errors.colorPalette || errors.colorPaletteOtherDetails}
          </p>
        )} */}
      </div>

      {/* Florals Section */}
      <div className="mb-6">
        <h4 className="mb-2 text-xl font-semibold">Florals</h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {floralOptions.map((option) => (
            <Input
              key={option.value}
              title={option.label}
              type="checkbox"
              name="florals"
              value={option.value}
              checked={formData.florals && formData.florals.split(", ").includes(option.value)}
              handleChange={handleChange}
              sectionStyles={`${sectionStyles.label} flex items-center`}
              // error={errors.florals}
              className={`mr-2 ${sectionStyles.checkbox}`}
            />
          ))}
        </div>
        <div className="flex flex-col md:w-full w-full">
          <Input
            title="Other:"
            type="text"
            name="floralsOtherDetails"
            value={formData.floralsOtherDetails || ""}
            handleChange={handleChange}
            sectionStyles={`${sectionStyles.label}`}
            // error={errors.floralsOtherDetails}
            className="flex-1 border-b-2 border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            disabled={!formData.floralsOtherChecked}
          />
        </div>

        {/* {(errors.florals || errors.floralsOtherDetails) && (
          <p className="text-red-500 text-sm">
            {errors.florals || errors.floralsOtherDetails}
          </p>
        )} */}
      </div>
    </section>
  );
};

export default WeddingStyle;
